import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  variant?: 'primary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg' | 'xl';
  fullWidth?: boolean;
  className?: string;
  href?: string;
}
export function Button({
  children,
  variant = 'primary',
  size = 'lg',
  fullWidth = false,
  className = '',
  href,
  ...props
}: ButtonProps) {
  const baseStyles = 'relative inline-flex items-center justify-center font-bold rounded-xl transition-all duration-300 overflow-hidden group';
  const variants = {
    primary: 'bg-gold-gradient text-black shadow-gold-glow hover:shadow-gold-glow-lg border border-gold-400/50',
    outline: 'bg-transparent border-2 border-gold-500 text-gold-400 hover:bg-gold-500/10',
    ghost: 'bg-transparent text-gray-300 hover:text-white hover:bg-white/5'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg md:text-xl',
    xl: 'px-10 py-5 text-xl md:text-2xl uppercase tracking-wide'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  const allClasses = `${baseStyles} ${variants[variant]} ${sizes[size]} ${widthClass} ${className}`;
  const content = <>
      {variant === 'primary' && <div className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/40 to-transparent group-hover:animate-[shimmer_1.5s_infinite]" data-id="element-294" />}
      <span className="relative z-10 flex items-center gap-2" data-id="element-295">{children}</span>
    </>;
  if (href) {
    return <motion.a href={href} target="_blank" rel="noopener noreferrer" whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} className={allClasses} data-id="element-296">
        {content}
      </motion.a>;
  }
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={allClasses} {...props} data-id="element-297">
      {content}
    </motion.button>;
}